export const AppRoute = {
  SELECT_GROUP: 'select-group',
  SETTINGS: 'settings',
  SETTINGS_LANGUAGES: 'settings-languages',
  SETTINGS_CONTACT: 'settings-contact',
  MAP: 'map',
  SCHEDULES: 'schedules',
  SEARCH: 'search',
  ROUTE_LIST: 'route-list',
  ROUTE_DETAILED: 'route-detailed',
  ON_DEMAND_ROUTE_DETAILED: 'on-demand-route-detailed',
  STOP_LIST: 'stop-list',
  STOP_DETAILED: 'stop-detailed',
  TRIP_DETAILED: 'trip-detailed',
  ITINERARY: 'itinerary',
  PASSENGER_MESSAGE: 'passenger-message',
  ROUTE_ALERTS: 'route-alerts',
  TIMETABLE: 'timetable',
  TRAIN_DEPARTURES: 'train-departures',
};

type QueryValue = string | null | Array<string | null> | undefined;

interface RouteLocationLike {
  name?: unknown;
  params: Record<string, unknown>;
  query: Record<string, QueryValue>;
}

/** A query param repeated in the URL (`?route=a&route=b`) keeps its first value. */
export function firstQueryValue(value: QueryValue): string | undefined {
  return (Array.isArray(value) ? value[0] : value) ?? undefined;
}

/**
 * The line the passenger is following: the one whose detail is open, or the one a
 * stop detail is narrowed to (`?route=`).
 */
export function followedRouteId(location: RouteLocationLike): string | undefined {
  if (location.name === AppRoute.ROUTE_DETAILED) return location.params.routeId as string | undefined;
  if (location.name === AppRoute.STOP_DETAILED) return firstQueryValue(location.query.route);
  return undefined;
}
